<template>
  <div>
    <v-app-bar color="primary" flat app dark>
      <v-app-bar-nav-icon style="position: absolute" @click="routerBack">
        <v-icon large color="white">mdi-chevron-left</v-icon>
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-app-bar-title v-if="child && clas" style="min-width: fit-content;">
        {{ (child.lastName + ' ' + child.firstName + '（' + clas.className + ' )').length > 14
            ? (child.lastName + ' ' + child.firstName + '（' + clas.className + ' )').slice(0, 14) + '…' 
            : child.lastName + ' ' + child.firstName + '（' + clas.className + ' )'
        }}
      </v-app-bar-title>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        variant="flat"
        icon
        @click="openSelectChildDialog"
        :loading="btnLoading"
        height="40"
        width="40"
      >
        <v-icon color="white">
          mdi-arrow-down-drop-circle-outline
        </v-icon>
      </v-btn>
    </v-app-bar>

    <v-dialog
      v-model="dialogFlg"
      width="280px"
      scrollable
    >
      <v-card class="selectItemList pb-0">
        <v-card-title>
          <!-- <v-select
            v-model="selectedClass"
            :items="classList"
            item-text="className"
            item-value="classId"
            @change="selectChildItems"
            filled
            menu-props="auto"
            hide-details
            return-object
            color="rgb(105,105,105)"
          > -->
          <v-select
            v-model="selectedClass"
            :items="classList"
            item-title="className"
            item-value="classId"
            @update:model-value="selectChildItems"
            variant="filled"
            hide-details
            return-object
            color="rgb(105,105,105)"
          >
          </v-select>
        </v-card-title>

        <v-card-text style="height: 40vh" class="childList">
          <v-list>
            <v-list-item
              v-for="(c,index) in childList"
              :key="index"
              @click="toClassChildrenRecords(c)"
            >
              <v-list-item-title> {{ c.name }} </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div @click="openDateDialog">
      <DatePager :date="date" @addDay="addDay" @subtractDay="subtractDay" />
    </div>
    <div color="text-grey" class="subtitle-wrapper d-flex align-center justify-center pt-3 pb-3">
      このページの記載内容は保護者には共有されません
    </div>

    <v-container class="pa-2">
      <v-textarea
        label="内容"
        v-model="content"
        variant="outlined"
        rows="17"
        hide-details
        density="compact"
        :loading="contentLoading"
      ></v-textarea>
    </v-container>
    <div class="d-flex justify-center">
    <v-btn
        color="primary"
        variant="flat"
        @click="saveContent"
        :loading="btnLoading"
      >
        保存
      </v-btn>
    </div>

    <v-snackbar v-model="snackbar" :timeout="timeout" outlined top color="primary">
      {{ snackBarText }}

      <!--<template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
          ×
        </v-btn>
      </template> -->
      <template v-slot:actions>
        <v-btn
          color="outline-primary"
          variant="text"
          @click="snackbar = false"
        >
          ×
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog
      v-model="dateDialogFlg"
      width="auto"
    >
        <v-date-picker
          v-model="selectedDate"
          type="date"
          :day-format="(date) => new Date(date).getDate()"
          @update:model-value="dateSelected"
          no-title
          hide-header
          color="primary"
          style="transform: scale(0.8);"
        >
        </v-date-picker>
    </v-dialog>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from "vue";

import DatePager from '@/components/molecules/DatePager.vue';

import dayjs from 'dayjs';
import ja from 'dayjs/locale/ja';
import LocalDataService from '@/service/LocalDataService';
import { nurseryModule } from '@/store/dataModules/nurseryModule';
import { childrenModule } from '@/store/dataModules/childrenModule';
import { diaryReportModule } from '@/store/dataModules/diaryReportModule';
import { DiaryResponse, NurseryChildResponse, NurseryClassResponse } from 'chaild-api/lib';
import { getDayjsInstanceTz} from 'chaild-api/src/common/moment/momentUtils';
dayjs.locale(ja);
export default defineComponent({
  components: {
    DatePager,
  },
  data: () => {
    return {
      btnLoading: false,
      contentLoading: false,
      date: '' as any,
      tabIndex: 0,
      time: '',
      content: '特記事項なし',
      childDiary: null as any,
      isRecordDialog: false,
      otherRecord: '',
      timeout: 2000,
      snackBarText: '',
      snackbar: false,
      classId: 0,
      childId: 0,
      nurseryId: 0,
      selectedClass: '' as any,
      year: dayjs().year(),
      month: dayjs().month(),
      dialogFlg: false,
      dateDialogFlg: false,
      selectedDate: dayjs().format('YYYY-MM-DD'),
      addflg: false,
      subtractflg: false,
      loadFlg: false,
      childList: [] as any,
      classList: [] as any,
      windowHistory: '' as any,
    };
  },
  computed: {
    clas(): NurseryClassResponse | null {
      if (nurseryModule.clas) {
        this.selectedClass = nurseryModule.clas;
        return nurseryModule.clas;
      }
      return null;
    },
    child(): NurseryChildResponse | null {
      if (childrenModule.child) {
        return childrenModule.child;
      }
      return null;
    },
  },
  watch: {
    date: {
      handler() {
        this.init();
        this.selectClassItems();
      },
      deep: true,
    },
  },
  methods: {
    routerBack() {
      this.snackbar = false;
      const routes = window.history.length
      console.log(routes)
      if (this.windowHistory === '') {
        if(routes > 1) {
          this.$router.back()
        } else {
          const classId = this.$route.params.classId;
          this.$router.push(`/record/class/${classId}`);
        }
      } else {
        const classId = this.windowHistory;
        this.$router.push(`/record/class/${classId}`);
      }
    },
    addDay() {
      this.date = this.date.add(1, 'd');
      this.addflg = true;
    },
    subtractDay() {
      this.date = this.date.subtract(1, 'd');
      this.subtractflg = true;
    },
    openDateDialog() {
      if (this.addflg || this.subtractflg) {
        this.addflg = false;
        this.subtractflg = false;
        return
      }
      this.selectedDate = this.date.format('YYYY-MM-DD');
      this.dateDialogFlg = true;
    },
    dateSelected(day) {
      this.date = dayjs(day);
      this.selectedDate = dayjs(day).format('YYYY-MM-DD');
      this.dateDialogFlg = false;
    },
    openSelectChildDialog() {
      this.dialogFlg = true;
      this.selectedClass = this.clas;
      this.selectChildItems();
    },
    //クラス情報取得（開いている個人日誌の日付を元に取得）
    async selectClassItems() {
      this.classList = [];
      this.month = dayjs(this.date).month();
      this.year = dayjs(this.date).year();
      if (this.month < 3) {
        this.year = this.year - 1;
      }
      if (this.nurseryId && this.year) {
        const classList = nurseryModule.getNurseryClassWithYear({
          nurseryId: this.nurseryId,
          year: this.year
        })
        this.classList = (await classList);
      }
      if (this.classList.length === 0) {
        this.classList.push({
          classId: 0,
          className: 'クラスが設定されておりません。',
        });
      }
    },
    //選択されているクラスに登録されている園児情報取得
    async selectChildItems() {
      this.childList = [];
      this.loadFlg = true;
      if (this.selectedClass.year == this.year) {
        const listData =  childrenModule.getChildren({
          nurseryId:this.nurseryId,
          classId: this.selectedClass.classId,
        });

        const arr = (await listData).children;
        const len = arr.length;
        const baseDay = getDayjsInstanceTz(this.date);
        for (let i = 0; i < len; i++) {
          if ((arr[i].graduationDate && baseDay.isAfter(getDayjsInstanceTz(arr[i].graduationDate!))) // 卒園済
            || (arr[i].quitDate && baseDay.isAfter(getDayjsInstanceTz(arr[i].quitDate!))) // 退園・転園済
            || (arr[i].admissionDate && getDayjsInstanceTz(arr[i].admissionDate).isAfter(baseDay)) // 入園前
          ) {
            continue;
          }
          this.childList.push({
            childId: arr[i].childId,
            name: arr[i].lastName + arr[i].firstName,
          })
        }
        this.loadFlg = false;
        return this.childList;
      } else {
        this.loadFlg = false;
      }
    },
    //選択した園児の個人日誌のページに遷移
    async toClassChildrenRecords(child: NurseryChildResponse) {
      if (this.windowHistory === '') {
        this.windowHistory = this.$route.params.classId;
      }

      //現在開いている園児以外を選択した時のみ this.$router.push を行う
      const childId = `${child.childId}`;
      if (this.$route.params.childId != childId) {
        await this.$router.push({
          path: `/record/class/${this.selectedClass.classId}/child/${child.childId}`,
          query: { date: `${this.date.toISOString()}` }
        });
      }

      this.init();
      this.dialogFlg = false;
    },
    saveContent: async function() {
      if (this.content) {
        this.btnLoading = true;
        if (this.childDiary && !this.childDiary.error) {
          try {
            const response = await diaryReportModule.updateChildDiary({
              childId: this.childId.toString(10),
              diaryId: this.childDiary.diaryId.toString(10),
              content: this.content,
            });
            this.childDiary = response;
            this.snackBarText = '保存しました';
            this.snackbar = true;
          } catch {}
        } else {
          try {
            const response = await diaryReportModule.createChildDiary({
              childId: this.childId,
              date: this.date.format('YYYY-MM-DD'),
              content: this.content,
            });
            this.childDiary = response;
            this.snackBarText = '保存しました';
            this.snackbar = true;
          } catch {}
        }
        this.btnLoading = false;
      }
    },
    init: async function() {
      try {
        // this.contentLoading = true
        const user = LocalDataService.getUser();
        const classId = this.$route.params.classId as string;
        const childId = this.$route.params.childId as string;
        this.classId = parseInt(classId, 10);
        this.childId = parseInt(childId, 10);
        if (user) {
          let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
          if (!nurserySchool) {
            nurserySchool = user.nurserySchools[0];
          }
          const nurseryId = nurserySchool.nurseryId;
          this.nurseryId = nurseryId;
          Promise.all([
            nurseryModule.getNurseryClassDetail({
              nurseryId,
              classId: this.classId,
            }),
            childrenModule.getChild(this.childId),
          ]);
          await diaryReportModule.fetchChildDiary({
            childId: this.childId,
            date: this.date.format('YYYY-MM-DD'),
          });
          this.content = '特記事項なし'
          if (diaryReportModule.childDiary) {
            this.childDiary = await diaryReportModule.childDiary;
            if (diaryReportModule.childDiary.content) {
              this.content = diaryReportModule.childDiary.content;
            }
          }
        }
      } catch {
      } finally {
        // this.contentLoading = false
      }
    },
  },
  async created() {
    const date = this.$route.query.date as string
    if (date) {
      const temp = dayjs(date);
      this.date = temp
    } else {
      this.date = dayjs();
    }
  },
  async mounted() {
    // const localText = LocalDataService.getDiaryText();
    // if (localText) {
    //   this.content = localText;
    // }
    this.init();
  },
  beforeDestroy() {
    childrenModule.refreshChild();
    nurseryModule.refreshClass();
    // if (this.content && !this.childDiary.content) {
    //   LocalDataService.setDiaryText(this.content);
    // } else {
    //   LocalDataService.removeDiaryText();
    // }
  },
});
</script>
<style lang="scss" scoped>
@use '@/sass/variables.scss' as *;

.subtitle-wrapper {
  background-color: #f5f6f6;
  font-size: 14px;
}
.full {
  height: 30px;
  width: 30px;
  border-radius: 100%;
  background-color: rgb(var(--v-theme-primary));
}
.selectItemList {
  width: 100%;
}
.childList {
  font-size: 15px;
}
</style>
